import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import StickyDonate from "@/components/StickyDonate";
import { Toaster } from "@/components/ui/sonner";

export default function Layout() {
    const location = useLocation();
    return (
        <div className="min-h-screen flex flex-col bg-caireen-cream text-caireen-ink">
            <Header />
            <main className="flex-1 pt-20 md:pt-24">
                <AnimatePresence mode="wait">
                    <motion.div
                        key={location.pathname}
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -8 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <Outlet />
                    </motion.div>
                </AnimatePresence>
            </main>
            <Footer />
            <StickyDonate />
            <Toaster richColors position="top-center" />
        </div>
    );
}
